import React, { useMemo } from "react";
import { useSelector } from "react-redux";

import { AppState } from "shared/data/reducers";
import { cutString } from "shared/lib/stringFormat";
import Logger from "shared/services/Logger";

type Props = {
  fileServerData?: any;
  src: string;
  className?: string;
  style?: any;
  id?: string;
  onClick?: () => void;
  onError?: (any) => void;
  alt?: string;
  title?: string;
  role?: string;
  width?: number;
  height?: number;
  loading?: "eager" | "lazy";
};

const MAX_LOGGED_IMAGE_SRC_LENGTH = 300;

export const getFileServerImageAddress = (
  src: string,
  fileServerData?: Record<string, string>
): string => {
  const imageName = `images/${src.split("/").pop()}`;
  return fileServerData?.[imageName] || src;
};

const Img: React.FC<Props> = ({
  src,
  className,
  id,
  style,
  onClick,
  onError,
  alt,
  title,
  role,
  width,
  height,
  loading,
}) => {
  const fileServerData = useSelector(
    (state: AppState) => state.requestorConfig.fileServerData
  );

  const imgAddress = useMemo(() => {
    const address = getFileServerImageAddress(src, fileServerData);
    if (fileServerData && address === src) {
      Logger.info(
        `Image ${cutString(
          src,
          MAX_LOGGED_IMAGE_SRC_LENGTH
        )} not found on fileserver. Serving default.`
      );
    }
    return address;
  }, [src, fileServerData]);

  return (
    // eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions
    <img
      loading={loading}
      src={imgAddress || src}
      className={className || ""}
      {...(id && { id })}
      style={style || {}}
      onClick={onClick}
      onError={onError}
      alt={alt}
      title={title || ""}
      role={role}
      width={width}
      height={height}
    />
  );
};

export default Img;
